import { apiPost, API_URI, apiGet } from "api";

const subscription = {
    byBoardId: async (boardId: number) => {
        const data = await apiGet(`${API_URI}/api/subscription/board/${boardId}`);
        return data;
    },
    byTicketId: async (ticketId: number) => {
        const data = await apiGet(`${API_URI}/api/subscription/ticket/${ticketId}`);
        return data;
    },
    byContactId: async (contactId: number) => {
        const data = await apiGet(`${API_URI}/api/subscription/contact/${contactId}`);
        return data;
    },
    hasBoardSubscription: async (boardId: number, contactId: number) => {
        const data = await apiGet(`${API_URI}/api/subscription/subscribed/board/${boardId}/${contactId}`);
        return data;
    },
    insert: async (contactId: number, boardId: number, ticketId: number | null, ) => {
        const data = await apiPost(`${API_URI}/api/subscription`, { ContactId: contactId, BoardId: boardId, TicketId: ticketId });
        return data;
    },
    delete: async (subscriptionId: number) => {
        const data = await apiPost(`${API_URI}/api/subscription/delete/${subscriptionId}`);
        return data;
    }
}


export default subscription;